module.exports = __webpack_public_path__ + "img/user_def.0d788bc6.png";